/** 페이지 로더 스피너 (public/assets/images) */
export const LOADER_SPINNER_URL = '/assets/images/loader-spinner.svg'

/** QR 중앙 로고 (public/assets/images) */
export const LOADER_LOGO_URL = '/assets/images/log_s.png'
